import ChartTab from "./ChartTab";
import React from "react";
import computeDefaultTableSize from "../../tools/computeDefaultTableSize";

class ChartCategoryTabPure extends React.Component {
  render() {
    const { data } = this.props;

    console.log("ChartCategoryTabPure", this.props);
    return (
      <ChartTab
        {...this.props}
        defaultPageSize={computeDefaultTableSize(
          data,
          "category.categoryFamily.name"
        )}
        pivots={["family", "category", "tiers"]}
        data={data}
        showColumns={["family", "category", "tiers"]}
        showPagination={false}
        showDetails={true}
        showExtra={true}
        defaultSorted={[
          {
            id: "family",
            desc: false
          }
        ]}
      />
    );
  }
}

export default ChartCategoryTabPure;
